<router-outlet>
  <!-- Page content -->
</router-outlet>
